import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ITablePagerOptions} from "../../../../shared/shared/table/components/table-pager/ITablePagerOptions";
import {ITableColumn} from "../../../../shared/shared/table/table-column";
import {IExportCSVPreview} from "./IExport-csv-preview";

export interface IExportColumn {
    id: number,
    text: string,
    field: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface IExportOptions<T>{

}



@Component({
    selector: 'app-export-csv-modal',
    templateUrl: './export-csv-modal.component.html',
    styleUrls: ['./export-csv-modal.component.scss']
})
export class ExportCsvModalComponent<T extends  IExportOptions<R>, R> implements OnInit{

    @Input() fetchPreviewMethod: (page)=> void;
    @Input() loading: boolean;
    @Input() data: IExportCSVPreview<T>;
    @Input() columns: ITableColumn[] = [];
    @Input() exportFormat: 'csv' | 'xlsx' = 'csv';
    @Output() export: EventEmitter<IExportOptions<R>> = new EventEmitter();
    @Output() pageChange: EventEmitter<number> = new EventEmitter();

    get items (){
        return this?.data?.data;
    }

    get pageOptions():ITablePagerOptions{
        if(this.data){
            return {
                currentPage: this.data.current_page,
                pagesCount: this.data.last_page,
                pageSize: this.data.per_page,
                total: this.data.total
            }
        }

        return null;
    }


    visibleColumns: ITableColumn[] = [];

    onColumnDeletion(column: ITableColumn): void {
        const columnIndex = this.visibleColumns.findIndex(x=>x.field === column.field);
       if (columnIndex >= 0 && this.visibleColumns.length >1) {
           this.visibleColumns.splice(columnIndex, 1);
       }
    }

    constructor(public activeModal: NgbActiveModal) {
    }

    dismissModal() {
        this.activeModal.dismiss();
    }

    onDownloadClick() {
        this.export.next({} as T);
    }

    ngOnInit(): void {
        this.visibleColumns = [...this.columns];
        this.pageChange.next(1);
    }

    onPageChange(page: number) {
        this.pageChange.next(page);
    }
}
